import { connect } from "react-redux";
import Settings from "./Settings";
import { updateAccountSettings, updateLogo, getSettingsRequest } from '../../store/actions/general.actions';
import { getSettings, loading, updateLogoLoading } from '../../store/selectors/general.selector';

const mapDispatchToProps = { updateAccountSettings, updateLogo, getSettingsRequest };

const mapStateToProps = (state) => { 
    let settings = getSettings(state);
    const accountLoading = loading(state);
    const logoLoading = updateLogoLoading(state);

    if (Object.keys(settings).length === 0) {
        settings = JSON.parse(localStorage.getItem('settings'));
    }
    
    return { settings, accountLoading, logoLoading };
 };

export default connect(mapStateToProps, mapDispatchToProps)(Settings);